import React from 'react';
import { FlexBox } from '@monorepo/ui-kit';
import Column from '../Column';
import styles from './index.module.css';

const MultiColumn: FC = ({ className = '', layout, components }) => {
  const { columns, type } = layout;

  return (
    <FlexBox
      className={`${styles.wrap} ${styles[type]} ${className}`}
      // align={FLEX_ALIGN.start}
    >
      {columns.map((column: string[]) => (
        <Column
          key={column.join('/')}
          column={column}
          className={styles.column}
          components={components}
        />
      ))}
    </FlexBox>
  );
};

export default MultiColumn;
